
<div class="plain-page">
    <cl-header-minimal></cl-header-minimal>
    <hr class="divider">
    <main>
        <cookie-info></cookie-info>
    </main>
    <hr class="divider">
    <cl-footer cookieLink="/CookieInfo"></cl-footer>
</div>